import React from 'react';

import { Sticky } from '../../hoc/sticky/sticky';
import { DeviceContext } from '../../../contexts/device/device';
import { replaceVal } from '../../../utils/formatting';
import { __ } from '../../../utils/translation-service';

import {
    StyledSubpageSticky,
} from './subpage-sticky-bar.style';
import { DreamlinesButton } from '../../atoms/dreamlines-button/dreamlines-button';
import { BackButton } from '../../atoms/back-button/back-button';

interface ISubpageStickyBar {
    shipUrl: string;
    observerRef: React.RefObject<HTMLElement | null>;
    onSearchSubmit: () => void;
}

export const SubpageStickyBar = (props: ISubpageStickyBar) => {
    const device = React.useContext(DeviceContext);

    const formattedOfferCount = replaceVal(__('seeAllOffers'), '');

    return (
        <Sticky observerRef={props.observerRef}>
            {(sticky) => (
                <StyledSubpageSticky>
                    <div className="container">
                        <BackButton href={props.shipUrl}>
                            {__('backToShipOverview')}
                        </BackButton>

                        {device !== 'mobile' && (
                            <DreamlinesButton
                                wrapperStyle={{
                                    marginLeft: 'auto',
                                }}
                                style={{
                                    borderRadius: '6px',
                                    fontWeight: '600',
                                }}
                                onClick={props.onSearchSubmit}
                            >
                                {formattedOfferCount}
                            </DreamlinesButton>
                        )}
                    </div>
                </StyledSubpageSticky>
            )}
        </Sticky>
    );
};
